<template>
  <div class="block-chart" :id="title" :style="styleCustom">
    <div class="header-chart">
      <div
        class="flex-row flex__between"
        style="cursor: pointer"
        @click="$emit('viewMore')"
      >
        <i style="margin-right: 10px" class="fal fa-chart-pie color__white"></i>
        <span>{{ title }}</span>
        <!-- <el-tooltip content="Xem thêm" placement="top"> -->
        <i
          class="far fa-arrow-to-right color__white font-size__large clickable"
        ></i>
        <!-- </el-tooltip> -->
        <!-- <div @click="export2image" class="btn btn-default">
          <i class="far fa-download color__smoke"></i>
        </div> -->
      </div>
      <div class="right-action" v-if="!styleCustom">
        <!-- <div @click="fullScreen">
          <i class="fal fa-expand-arrows color__smoke"></i>
        </div> -->
        <div @click="$emit('removeItem')">
          <i class="fal fa-times color__smoke"></i>
        </div>
      </div>
    </div>
    <div class="content-chart">
      <pie-chart
        v-if="checkDisplayChart()"
        :data="chartData"
        :options="chartOptions"
      ></pie-chart>
      <div v-else class="flex-row flex__center" style="height: 100%">
        <i
          class="fas fa-ban color__silver font-size__larger margin-right-10"
        ></i>
        <span class="font-size__medium font-weight__bold opacity-50"
          >Không có dữ liệu
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from "./PieChart.js";
export default {
  watch: {},
  name: "mainContent",
  props: ["title", "styleCustom", "dataChart", "type"],
  components: {
    PieChart,
  },

  data() {
    return {
      chartOptions: {
        hoverBorderWidth: 20,
        legend: {
          position: "bottom",
          labels: {
            fontSize: 13,
            fontFamily:
              "'Roboto', sans-serif, 'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial'",
          },
        },
        responsive: true,
      },
      chartData: {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: [
          "Chờ phê duyệt",
          "Chưa hoàn thành",
          "Hoàn thành",
          "Kết thúc",
          "Tạm dừng/Hủy",
        ],
        datasets: [
          {
            label: "Data One",
            backgroundColor: [
              "#43ACFF",
              "#FBB440",
              "#4caf50",
              "#41B883",
              "#f44336",
            ],
            data: [],
          },
        ],
      },
    };
  },
  created() {
    this.setDataForChart();
  },
  methods: {
    checkDisplayChart() {
      let check = false;
      if (this.dataChart && this.dataChart.length) {
        this.dataChart.map((item) => {
          if (item) check = true;
        });
      }
      return check;
    },

    setDataForChart() {
      this.chartData.datasets[0].data = this.dataChart;
    },
    export2image: function () {
      let canvas = document
        .getElementById(this.title)
        .querySelector("#doughnut-chart")
        .toDataURL("image/png");
      let link = document.createElement("a");
      link.download = "image";
      link.href = canvas;
      link.click();
    },
    fullScreen() {
      this.$emit("fullScreen", { title: this.title, data: this.chartData });
    },
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/home/components/PieChart.vue